const isDateOverADay = (date: string | Date): boolean => {
	const then = new Date(date);
	const now = new Date();

	const hoursInADay = 24;

	const msBetweenDates = Math.abs(then.getTime() - now.getTime());

	const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

	return hoursBetweenDates > hoursInADay;
};

export default isDateOverADay;
